exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".deleteType-87ac4{width:100%}.label-1569f{display:inline-block;margin-bottom:12px;font-size:16px}", ""]);

// Exports
exports.locals = {
	"deleteType": "deleteType-87ac4",
	"label": "label-1569f"
};